<template>
  <div>
    <Layout ref="layoutRef" :selectedOption="3" />

    <!-- Breadcrumb y ayuda -->
    <div class="mb-3">
      <div class="row">
        <div class="col-11">
          <div class="breadcrumb-container">
            <router-link to="/prestador">Prestador</router-link> >
            <router-link
              :to="'/prestador_elempres/' + datoElemPres.idPrestador"
              >{{ datoElemPres.prestadorRazonSocial }}</router-link
            >
            > Código: {{ datoElemPres.codigo }}
          </div>
        </div>
        <div class="col-1">
          <span
            class="material-symbols-outlined"
            style="font-size: 32px; color: blue; cursor: pointer"
            @click="showModalHelp = true"
          >
            help
          </span>
        </div>
      </div>
    </div>

    <!-- Master -->
    <div class="modal-dialog modal-xl">
      <div class="modal-content">
        <form>
          <div class="modal-body">
            <div class="mb-3">
              <div class="row">
                <div class="col-1">
                  <strong>Id.</strong>
                </div>
                <div class="col-1">
                  <span>{{ datoElemPres.idElemPres }}</span>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-1">
                  <strong>Código</strong>
                </div>
                <div class="col-1">
                  <span style="text-transform: uppercase">{{
                    datoElemPres.codigo
                  }}</span>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-1">
                  <strong>Nombre</strong>
                </div>
                <div class="col-11">
                  <span style="text-transform: uppercase">{{
                    datoElemPres.nombre
                  }}</span>
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>

    <!-- Details -->
    <hr />
    <div class="mb-3">
      <table class="tablaBusqueda">
        <tr>
          <td><label for="nombre" class="form-label">Nombre</label></td>
          <td>
            <input
              type="text"
              class="form-control"
              id="nombreBusqueda"
              name="nombreBusqueda"
              v-model="nombreBusqueda"
              style="width: 500px; text-transform: uppercase"
              required
            />
          </td>
          <td class="centro">
            <button
              type="submit"
              class="btn btn-light"
              @click.prevent="getDataPagina(1)"
              title="Buscar registros"
            >
              <i
                class="material-icons"
                style="font-size: 24px; color: blue; cursor: pointer"
                >search</i
              >
              Buscar
            </button>
          </td>
          <td class="centro">
            <button
              type="submit"
              class="btn btn-light"
              @click.prevent="getDataPaginaTodos(1)"
              title="Todos los registros"
            >
              <i
                class="material-icons"
                style="font-size: 24px; color: blue; cursor: pointer"
                >auto_awesome_motion</i
              >
            </button>
          </td>
          <td>
            <button
              type="submit"
              class="btn btn-light"
              data-bs-toggle="modal"
              data-bs-target="#ventanaModal"
              @click="abrirModalCrear"
              title="Nuevo registro"
            >
              <i
                class="material-icons"
                style="font-size: 24px; color: green; cursor: pointer"
                >add_box</i
              >Nuevo registro
            </button>
          </td>
        </tr>
      </table>
    </div>
    <table class="table table-striped" id="sampleTable">
      <thead>
        <tr>
          <th scope="col"></th>
          <th scope="col"></th>
          <th scope="col">ID</th>
          <th scope="col">Nombre Estándar</th>
          <th scope="col">Nombre en P.S.</th>
          <th scope="col">Estado</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="elemequi in datosPaginados" :key="elemequi.idElemEqui">
          <td>
            <i
              class="material-icons"
              style="font-size: 16px; color: orangered; cursor: pointer"
              @click="abrirModalEditar(elemequi.idElemEqui)"
              title="Editar"
              >edit_square</i
            >
          </td>
          <td>{{ elemequi.idElemEqui }}</td>
          <td>{{ elemequi.elementoNombre }}</td>
          <td>{{ elemequi.elemPresNombre }}</td>
          <td>{{ elemequi.estado }}</td>
          <td>
            <i
              class="material-icons"
              style="font-size: 16px; color: red; cursor: pointer"
              @click="deleteElemPres(elemequi.idElemEqui)"
              title="Borrar"
              >delete</i
            >
          </td>
        </tr>
      </tbody>
    </table>
    <nav aria-label="Page navigation example">
      <ul class="pagination">
        <li class="page-item" v-on:click="getPreviousPage()">
          <a class="page-link" href="#">Anterior</a>
        </li>
        <li
          id="lugar"
          v-for="pagina in totalPaginas()"
          v-bind:key="pagina"
          v-on:click="getDataPagina(pagina)"
          class="page-item"
          v-bind:class="isActive(pagina)"
        >
          <a class="page-link" href="#">{{ pagina }}</a>
        </li>
        <li class="page-item" v-on:click="getNextPage()">
          <a class="page-link" href="#">Siguiente</a>
        </li>
      </ul>
    </nav>
    <!-- Modal -->
    <div
      class="modal fade"
      id="ventanaModal"
      tabindex="-1"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
      v-if="modalWindow"
    >
      <div class="modal-dialog modal-xl">
        <div class="modal-content">
          <div class="modal-header bg-primary">
            <h5 class="modal-title" id="exampleModalLabel">
              <i class="fa fa-user-plus"></i> {{ titulo }}
            </h5>
            <button
              type="button"
              class="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>
          <form>
            <div class="modal-body">
              <!--		
            <div class="mb-3" v-if="btnEditar_det">
              <div class="row">
                <div class="col-2">
                  <label for="idElemEqui" class="form-label">IdElemEqui</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="idElemEqui" name="idElemEqui" v-model="datoElemEqui.idElemEqui" disabled>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="idElemPres" class="form-label">IdElemPres</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="idElemPres" name="idElemPres" v-model="datoElemEqui.idElemPres" style='text-transform:uppercase' required>
                </div>
              </div>
            </div>
-->
              <div class="mb-3">
                <!-- Botón Lista de Valores -->
                <div class="row">
                  <div class="col-12">
                    <label for="idElemento" class="form-label"> Elemento</label>
                    <select
                      class="form-control"
                      id="idElemento"
                      name="idElemento"
                      v-model="datoElemEqui.idElemento"
                    >
                      <option
                        v-for="elemento in elementos"
                        :value="elemento.idElemento"
                        :key="elemento.idElemento"
                      >
                        {{ elemento.clasElemNombre }} - {{ elemento.codigo }} -
                        {{ elemento.nombre }}
                      </option>
                    </select>
                  </div>
                </div>
                <!-- Botón Lista de Valores -->
              </div>
            </div>
          </form>
          <div class="modal-footer">
            <button
              type="submit"
              class="btn btn-light"
              @click.prevent="guardarElemEqui"
              v-if="btnCrear_det"
              title="Guardar"
            >
              <i
                class="material-icons"
                style="font-size: 32px; color: blue; cursor: pointer"
                >save</i
              >
            </button>
            <button
              type="submit"
              class="btn btn-light"
              @click.prevent="guardarEditElemEqui"
              v-if="btnEditar_det"
              title="Actualizar"
            >
              <i
                class="material-icons"
                style="font-size: 32px; color: blue; cursor: pointer"
                >update</i
              >
            </button>
          </div>
        </div>
      </div>
    </div>
    <!-- Details -->

    <Footer />
  </div>
</template>
<script>
import Layout from "@/components/Layout.vue";
import Footer from "@/components/Footer.vue";
import api from "@/services/api";
import { validarForm } from "../../modules/validacionesForms.js";
import dateFormat from "../../modules/dateFormat.js";

import * as $ from "jquery";
window["$"] = $;
window["jQuery"] = $;
import swal from "sweetalert";
export default {
  components: {
    Layout,
    Footer,
  },
  data() {
    return {
      // Variables master
      elempress: [],
      datoElemPres: {},
      nombreBusqueda: "",
      titulo: "",
      btnCrear: false,
      btnEditar: false,
      p_idElemPres: "",
      prestadors: [],
      // Variables master
      // Variables details
      elemequis: [],
      datoElemEqui: {},
      nombreBusqueda_det: "",
      titulo_det: "",
      btnCrear_det: false,
      btnEditar_det: false,
      elementosPorPagina: 10,
      datosPaginados: [],
      paginaActual: 1,
      elemPress: [],
      elementos: [],
      modalWindow: true,
      // Variables details
    };
  },
  mounted() {
    this.p_idElemPres = this.$route.params.p_idelempres;
    this.abrirEditar(this.p_idElemPres);
    this.$refs.layoutRef.toggleProcesos();
    this.$refs.layoutRef.toggleReportes();
    this.$refs.layoutRef.toggleParametros();
    this.$refs.layoutRef.toggleAyuda();
    this.getDataPaginaTodos(this.paginaActual);
    this.fetchElementos();
  },
  methods: {
    getFormattedDate(date) {
      return dateFormat.getFormattedDate(date);
    },
    // Procedimientos master
    validarForm() {
      const requiredFields = ["idPrestador", "codigo", "nombre"];
      const requiredFieldsText = ["idPrestador", "codigo", "nombre"];
      return validarForm(this.datoElemPres, requiredFields, requiredFieldsText);
    },
    abrirCrear() {
      this.modalWindow = true;
      this.datoElemPres = {};
      this.titulo = "Crear ";
      this.btnCrear = true;
      this.btnEditar = false;
    },
    abrirEditar(idElemPres) {
      this.modalWindow = true;
      if (idElemPres != null) {
        api.get("/vwelempress/" + idElemPres)
          .then((resp) => {
            this.datoElemPres = resp.data;
          });
      }
      this.titulo = "Editar ";
      this.btnCrear = false;
      this.btnEditar = true;
    },
    cerrarElemPres() {
      this.$router.push("/ElemPres");
    },
    // Procedimientos master
    // Procedimientos detalle
    totalPaginas() {
      return Math.ceil(this.elemequis.length / this.elementosPorPagina);
    },
    getDataPagina(noPagina) {
      if (this.nombreBusqueda != "") {
        api.get("/vwelemequis/nombre/" +
              this.nombreBusqueda
          )
          .then((response) => {
            this.elemequis = response.data.reverse();
            this.paginaActual = noPagina;
            this.datosPaginados = [];
            let ini =
              noPagina * this.elementosPorPagina - this.elementosPorPagina;
            let fin = noPagina * this.elementosPorPagina;
            this.datosPaginados = this.elemequis.slice(ini, fin);
          });
      }
    },
    getDataPaginaTodos(noPagina) {
      api.get("/vwelemequis/idelempres/" +
            this.p_idElemPres
        )
        .then((response) => {
          this.elemequis = response.data.reverse();
          this.paginaActual = noPagina;
          this.datosPaginados = [];
          let ini =
            noPagina * this.elementosPorPagina - this.elementosPorPagina;
          let fin = noPagina * this.elementosPorPagina;
          this.datosPaginados = this.elemequis.slice(ini, fin);
        });
    },
    getPreviousPage() {
      if (this.paginaActual > 1) {
        this.paginaActual--;
      }
      this.getDataPagina(this.paginaActual);
    },
    getNextPage() {
      if (this.paginaActual < this.totalPaginas()) {
        this.paginaActual++;
      }
      this.getDataPagina(this.paginaActual);
    },
    isActive(noPagina) {
      return noPagina == this.paginaActual ? "active" : "";
    },
    validarFormDet() {
      const requiredFields = ["idPrestador", "codigo", "nombre"];
      const requiredFieldsText = ["idPrestador", "codigo", "nombre"];
      return validarForm(this.datoElemPres, requiredFields, requiredFieldsText);
    },
    async guardarElemEqui() {
      if (this.validarForm() === 1) {
        try {
          this.datoElemEqui.idElemPres = this.datoElemPres.idElemPres;
          await api.post("/elemequis",
            this.datoElemEqui
          );
          $("#ventanaModal").modal("hide");
          swal("Correcto!", "ElemEqui creada exitosamente!", "success");
          this.getDataPagina(this.paginaActual);
        } catch (error) {
          swal("Error!", "Intentelo de nuevo!", "error");
        }
      }
    },
    async guardarEditElemEqui() {
      if (this.validarForm() === 1) {
        try {
          await api.post("/elemequis",
            this.datoElemEqui
          );
          $("#ventanaModal").modal("hide");
          this.getDataPagina(this.paginaActual);
          swal("Correcto!", "ElemEqui creado(a) exitosamente!", "success");
        } catch (error) {
          swal("Error!", "Intentelo de nuevo!", "error");
          var array = Object.values(error.response.data.errors);
          array.forEach((element) => swal(String(element)));
        }
      }
    },
    abrirModalCrear() {
      this.modalWindow = true;
      this.datoElemEqui = {};
      this.titulo = "Crear ";
      this.btnCrear_det = true;
      this.btnEditar_det = false;
    },
    abrirModalEditar(idElemEqui) {
      this.modalWindow = true;
      if (idElemEqui != null) {
        api.get("/vwelemequis/" + idElemEqui)
          .then((resp) => {
            this.datoElemEqui = resp.data;
          });
      }
      $("#ventanaModal").modal("show");
      this.titulo = "Editar ";
      this.btnCrear_det = false;
      this.btnEditar_det = true;
    },
    async deleteElemEqui(idElemEqui) {
      try {
        await api.delete("/elemequis/" + idElemEqui
        );
        this.getDataPagina(this.paginaActual);
      } catch (error) {
        alert("No se pudo eliminar");
      }
    },
    // Procedimientos detalle
    async fetchElemPress() {
      try {
        const response = await api.get("/vwelempress");
        this.elemPress = response.data;
      } catch (error) {
        console.error("Error fetching elemPress:", error.response?.data || error.message);
      }
    },

    async fetchElementos() {
      try {
        const response = await api.get("/vwelementos");
        this.elementos = response.data;
      } catch (error) {
        console.error("Error fetching elementos:", error.response?.data || error.message);
      }
    },
  },
};
</script>
